import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { DEPT_PUBLICATIONS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/publications/")({
  component: () => <DeptContentList cfg={DEPT_PUBLICATIONS} />,
});
